var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCasinoW({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_1276)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C8.21997 1 6.47991 1.52784 4.99987 2.51677C3.51983 3.50571 2.36628 4.91131 1.68509 6.55585C1.0039 8.20038 0.825669 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.364C4.89472 17.6226 6.49836 18.4798 8.24419 18.8271C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.4722 13.5201 19 11.78 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.387 1 10 1ZM10 16C8.81332 16 7.65328 15.6481 6.66658 14.9888C5.67989 14.3295 4.91085 13.3925 4.45673 12.2961C4.0026 11.1997 3.88378 9.99334 4.11529 8.82946C4.3468 7.66557 4.91825 6.59647 5.75736 5.75736C6.59648 4.91824 7.66558 4.3468 8.82946 4.11529C9.99335 3.88378 11.1997 4.0026 12.2961 4.45672C13.3925 4.91085 14.3295 5.67988 14.9888 6.66658C15.6481 7.65327 16 8.81331 16 10C16 11.5913 15.3679 13.1174 14.2426 14.2426C13.1174 15.3679 11.5913 16 10 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433296 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 18.75C8.26942 18.75 6.57769 18.2368 5.13876 17.2754C3.69983 16.3139 2.57833 14.9473 1.91606 13.3485C1.25379 11.7496 1.08051 9.99029 1.41813 8.29296C1.75575 6.59563 2.58911 5.03653 3.81282 3.81282C5.03653 2.58911 6.59563 1.75575 8.29296 1.41813C9.9903 1.08051 11.7496 1.25379 13.3485 1.91605C14.9473 2.57832 16.3139 3.69983 17.2754 5.13876C18.2368 6.57769 18.75 8.26941 18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3417 8.28052L6.4126 11.1506L6.65369 11.7327L13.5828 8.86256L13.3417 8.28052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84722 6.4187L8.27441 6.65597L11.1445 13.5851L11.7173 13.3478L8.84722 6.4187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56994 7.18993C8.91788 7.18993 9.19994 6.90787 9.19994 6.55993C9.19994 6.21199 8.91788 5.92993 8.56994 5.92993C8.222 5.92993 7.93994 6.21199 7.93994 6.55993C7.93994 6.90787 8.222 7.18993 8.56994 7.18993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4301 14.0601C11.7725 14.0601 12.0501 13.7825 12.0501 13.4401C12.0501 13.0977 11.7725 12.8201 11.4301 12.8201C11.0877 12.8201 10.8101 13.0977 10.8101 13.4401C10.8101 13.7825 11.0877 14.0601 11.4301 14.0601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4401 9.19994C13.788 9.19994 14.0701 8.91788 14.0701 8.56994C14.0701 8.222 13.788 7.93994 13.4401 7.93994C13.0922 7.93994 12.8101 8.222 12.8101 8.56994C12.8101 8.91788 13.0922 9.19994 13.4401 9.19994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56018 12.06C6.90812 12.06 7.19018 11.778 7.19018 11.43C7.19018 11.0821 6.90812 10.8 6.56018 10.8C6.21224 10.8 5.93018 11.0821 5.93018 11.43C5.93018 11.778 6.21224 12.06 6.56018 12.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.75C8.76387 3.75 7.5555 4.11656 6.52769 4.80331C5.49988 5.49007 4.6988 6.46619 4.22576 7.60823C3.75271 8.75027 3.62894 10.0069 3.87009 11.2193C4.11125 12.4317 4.70651 13.5453 5.58059 14.4194C6.45466 15.2935 7.56831 15.8888 8.78069 16.1299C9.99307 16.3711 11.2497 16.2473 12.3918 15.7742C13.5338 15.3012 14.5099 14.5001 15.1967 13.4723C15.8834 12.4445 16.25 11.2361 16.25 10C16.25 8.3424 15.5915 6.75269 14.4194 5.58058C13.2473 4.40848 11.6576 3.75 10 3.75ZM10 15C9.0111 15 8.0444 14.7068 7.22215 14.1573C6.39991 13.6079 5.75904 12.827 5.38061 11.9134C5.00217 10.9998 4.90315 9.99445 5.09608 9.02455C5.289 8.05464 5.76521 7.16373 6.46447 6.46447C7.16373 5.7652 8.05465 5.289 9.02455 5.09607C9.99446 4.90315 10.9998 5.00216 11.9134 5.3806C12.8271 5.75904 13.6079 6.3999 14.1574 7.22215C14.7068 8.04439 15 9.01109 15 10C15 11.3261 14.4732 12.5979 13.5355 13.5355C12.5979 14.4732 11.3261 15 10 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8902 8.99995L18.7102 8.19995C18.4769 7.13305 18.0535 6.11684 17.4602 5.19995L14.1802 7.26995C14.5273 7.79486 14.7685 8.38254 14.8902 8.99995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8902 11C14.7648 11.607 14.5237 12.1841 14.1802 12.7L17.4602 14.83C18.1632 13.9749 18.5981 12.9313 18.7102 11.83L14.8902 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14.8899L11.8 18.7099C12.8801 18.5201 13.9047 18.0932 14.8 17.4599L12.67 14.1799C12.1632 14.52 11.5965 14.7609 11 14.8899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27014 14.1799L5.14014 17.4599C5.96299 18.2149 7.02465 18.6573 8.14015 18.7099L9.00014 14.8899C8.38273 14.7682 7.79505 14.527 7.27014 14.1799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11004 11L1.29004 11.8C1.38683 12.9051 1.8235 13.9531 2.54004 14.8L5.82004 12.67C5.47999 12.1632 5.23907 11.5965 5.11004 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82004 7.26989L2.54004 5.13989C1.85532 6.00585 1.42278 7.04394 1.29004 8.13989L5.11004 8.99989C5.23175 8.38248 5.47293 7.7948 5.82004 7.26989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99971 5.11004L8.19971 1.29004L5.19971 2.54004L7.26971 5.82004C7.79462 5.47293 8.3823 5.23175 8.99971 5.11004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.73 5.82004L14.86 2.54004L11.86 1.29004L11 5.11004C11.6174 5.23175 12.2051 5.47293 12.73 5.82004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_1276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCasinoW);
export default __webpack_public_path__ + "static/media/live-casino-W.107b30596e49a4621db5058256f8fcae.svg";
export { ForwardRef as ReactComponent };